const draftKey = (projectId) => `validaite-intake-draft-${projectId}`;

export function loadIntakeDraft(projectId) {
  if (!projectId) return null;
  try {
    const raw = localStorage.getItem(draftKey(projectId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveIntakeDraft(projectId, draft) {
  if (!projectId || !draft) return;
  try {
    localStorage.setItem(draftKey(projectId), JSON.stringify(draft));
  } catch {
    // localStorage full or unavailable — non-fatal
  }
}

export function clearIntakeDraft(projectId) {
  if (!projectId) return;
  try {
    localStorage.removeItem(draftKey(projectId));
  } catch {
    // ignore
  }
}
